/**
 * @description 库存分析-tabsFBA已接收库存模块
 */
<template>
    <div class="inventory-accepted">
        <app-filter-group
            @query="$gjQuery"
            @reset="$gjQueryInitParams">
            <gj-select-input
                v-model="filter.keyword"
                :options="[
                    {id: 'shipmentId', text: 'shipmentId'},
                    {id: 'shipmentName', text: '货件名称'},
                    {id: 'centerId', text: '亚马逊代码'}
                ]"
                :width="['120px', '100px']"
            ></gj-select-input>
            <gj-select-date-picker
                :width="['160px']"
                v-model="filter.date"
                :options="[
                {id: 'marketDate', text: '收货时间（零时区）'},
                {id: 'zeroZoneDate', text: '收货时间（市场时区）'},
                ]"
                type="daterange"
            ></gj-select-date-picker>
        </app-filter-group>
        <gj-table
            ref="gjTable"
            size='has-picture'
            name="flag"
            :data="tableData"
            :columns="columns"
            :loading="loading"
            :adapt-height="false"
            :index="false"
            :height="400"
            :default-sort="{prop: 'quantity', order: 'descending'}"
            border="default"
            @sort-change="$gjSortChange"
            @page-change="$gjNoticeQuery">
        </gj-table>
    </div>
</template>

<script>
import {isMeaningfulMixin, queryMixin, selectionMixin} from "@/minxins";
import { INVENTORY_ACCEPTED_COLUMN } from "../config.js"
import { storageAnalysisFbaReceived } from "@/api/statistics";
import { convertToDate } from "@/utils/date.util.js"
export default {
    mixins: [queryMixin, selectionMixin, isMeaningfulMixin],
    inject: ["getPageParams"],
    computed: {
        pageParams () {
            return this.getPageParams()
        },
    },
    data() {
        return {
            filter: {
                keyword: {
                    key: 'shipmentId',
                    value: ""
                },
                date: {
                    key: 'marketDate',
                    value: null,
                },
            },
            tableData: [],
            columns: INVENTORY_ACCEPTED_COLUMN,
            loading: false,
        }
    },
    methods: {
        $gjQueryInitParams() {
            this.filter.keyword = { key: 'shipmentId', value: null }
            this.filter.date = { key: 'marketDate', value: null }
        },
        $gjQuery() {
           this.storageAnalysisFbaReceived()
        },
        // 获取list数据
        async storageAnalysisFbaReceived() {
            this.loading = true
            try {
                let res = await storageAnalysisFbaReceived(this.structureParams()) || []
                this.tableData = res
            } finally {
                this.loading = false
            }
        },
        // 构造params
        structureParams() {
            let params = {
                asinCode: this.pageParams.asinCode, //ASIN类型值
                asinType: this.pageParams.asinType, //ASIN类型（子asin：child，父asin：parent）
                centerId: "", //亚马逊仓代码
                shipmentId: "", //ShipmentId
                shipmentName: "", //货件名称
                countryIds: this.pageParams.countryData.countryIds,
                marketIds: this.pageParams.countryData.marketIds,
                marketDateEnd: "", // 收货时间（市场时区）-结束
                marketDateStart: "", // 收货时间（市场时区）-开始
                zeroZoneDateEnd: "", // 收货时间（零时区）-结束
                zeroZoneDateStart: "", // 收货时间（零时区）-开始
                ...this.querySort
            }
            if (this.filter.keyword.key) {
                params[this.filter.keyword.key] = this.filter.keyword.value
            }
            if (this.filter.date.value && this.filter.date.key == 'marketDate') {
                params.marketDateStart = convertToDate(this.filter.date.value[0])
                params.marketDateEnd = convertToDate(this.filter.date.value[1])
            }
            if (this.filter.date.value && this.filter.date.key == 'zeroZoneDate') {
                params.zeroZoneDateStart = convertToDate(this.filter.date.value[0])
                params.zeroZoneDateEnd = convertToDate(this.filter.date.value[1])
            }
            return params
        }
    },
    created() {
        this.sort.prop = "quantity"
    }
};
</script>

<style scoped lang="scss">
.inventory-accepted {
    padding-top: 15px;
    /deep/.filter-group {
        padding-bottom: 10px;
    }
}
</style>
